import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  GetApp as ExportIcon,
  Assessment as AssessmentIcon,
  SyncAlt as MigrationIcon
} from '@mui/icons-material';

const ExportButton = ({ onExport, disabled = false, label = "Export", sx = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (mode) => {
    handleClose();
    if (onExport) {
      onExport(mode);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<ExportIcon />}
        onClick={handleClick}
        disabled={disabled}
        sx={sx}
      >
        {label} ▼
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleOptionClick('reporting')}>
          <ListItemIcon>
            <AssessmentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary="Export for Reporting" 
            secondary="Standard CSV/Excel" 
            primaryTypographyProps={{ variant: 'body2' }} 
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleOptionClick('migration')}>
          <ListItemIcon>
            <MigrationIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary="Export for Migration" 
            secondary="Includes System IDs" 
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportButton;
